module.exports = __webpack_public_path__ + "static/media/class_2.2207c4c0.svg";